module.exports = __webpack_public_path__ + "static/img/8.a1a2742.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/8.png
// module id = PXZH
// module chunks = 0